import React from 'react';
import Layout from '../components/Layout'; // Importa o Layout
import { PageProps } from '../App'; // Importa a interface PageProps
import NossaEquipeIMG from '../assets/nossa-equipe.png'; // Imagem representativa da equipe

// Adiciona PageProps à definição do componente
const SobreNosPage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    // Passa as props para o Layout
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <div className="bg-white dark:bg-gray-900">
        {/* Hero Section */}  
        <div className="relative hero-gradient overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-lupa-purple-dark/70 to-lupa-purple/30 z-10"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-20">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading">
                Sobre a Lupa Data
              </h1>
              <p className="mt-6 text-xl text-white/90 max-w-3xl mx-auto">
                Desvendando o potencial dos seus dados para transformar negócios.
              </p>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
              <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>

        {/* Nossa História */}
        <section className="py-16 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-6">Nossa Jornada</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                A Lupa Data nasceu da paixão por dados e da crença de que cada informação, por menor que seja, guarda um potencial imenso. Fundada por especialistas em Big Data, Inteligência Artificial e estratégias de negócio, nossa missão é ajudar empresas a enxergar além do óbvio, transformando dados brutos em insights acionáveis e resultados concretos.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Desde o início, focamos em construir soluções personalizadas, entendendo que cada cliente possui desafios e objetivos únicos. Combinamos tecnologia de ponta com uma abordagem consultiva para entregar não apenas ferramentas, mas parcerias estratégicas que impulsionam o crescimento e a inovação.
              </p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-lg">
              {/* Imagem representativa da equipe ou escritório */}
              <img src={NossaEquipeIMG} alt="Equipe Lupa Data" className="w-full h-auto object-cover" />
            </div>
          </div>
        </section>

        {/* Missão, Visão e Valores */}
        <section className="py-16 bg-gray-50 dark:bg-gray-800 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-12 text-center">Nossos Pilares</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Missão */}
              <div className="card text-center">
                <div className="w-16 h-16 mx-auto bg-lupa-orange/20 rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Missão</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Capacitar empresas a tomar decisões mais inteligentes e estratégicas através da democratização e potencialização dos seus dados.
                </p>
              </div>
              {/* Visão */}
              <div className="card text-center">
                <div className="w-16 h-16 mx-auto bg-lupa-orange/20 rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Visão</h3>
                <p className="text-gray-600 dark:text-gray-300">
                  Ser a referência em soluções de dados e inteligência artificial na América Latina, reconhecida pela inovação e impacto nos negócios dos nossos clientes.
                </p>
              </div>
              {/* Valores */}
              <div className="card text-center">
                <div className="w-16 h-16 mx-auto bg-lupa-orange/20 rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-lupa-orange" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Valores</h3>
                <ul className="text-gray-600 dark:text-gray-300 list-none space-y-1">
                  <li>Inovação Contínua</li>
                  <li>Parceria Estratégica</li>
                  <li>Excelência Técnica</li>
                  <li>Ética e Transparência</li>
                  <li>Foco no Cliente</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-16 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-lupa-orange to-lupa-yellow p-12 rounded-xl shadow-lg">
            <h2 className="text-3xl font-bold text-white mb-4">Vamos Conversar Sobre Seus Dados?</h2>
            <p className="text-lg text-white/90 mb-8">
              Entre em contato conosco para descobrir como a Lupa Data pode ajudar sua empresa a alcançar novos patamares através da inteligência de dados.
            </p>
            <a href="/contato" className="btn-secondary bg-white text-lupa-orange hover:bg-gray-100">
              Fale Conosco
            </a>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default SobreNosPage;
